import React, { useState } from 'react';
import { PlayIcon, ChevronDownIcon } from 'lucide-react';
export function CountryHero() {
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const scrollToTours = () => {
    const toursSection = document.getElementById('explore-tours-section');
    if (toursSection) {
      toursSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <div className="relative w-full" data-id="element-16">
      {/* Hero Image with Overlay */}
      <div className="relative h-[70vh] md:h-[80vh] w-full overflow-hidden" data-id="element-17">
        <img src="https://images.unsplash.com/photo-1530122037265-a5f1f91d3b99?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Swiss Alps with mountains and lake" className="absolute inset-0 w-full h-full object-cover" data-id="element-18" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" data-id="element-19"></div>
      </div>
      {/* Hero Content */}
      <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-4" data-id="element-20">
        <div className="max-w-4xl" data-id="element-21">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 drop-shadow-md" data-id="element-22">
            Discover the Magic of Switzerland
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto drop-shadow-md" data-id="element-23">
            Alpine peaks, crystal-clear lakes, and charming villages await in
            this pristine wonderland
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-24">
            <button className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition-colors min-w-[160px]" onClick={scrollToTours} data-id="element-25">
              Explore Tours
            </button>
            <button onClick={() => setVideoModalOpen(true)} className="px-6 py-3 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white font-medium rounded-md transition-colors flex items-center justify-center min-w-[160px]" data-id="element-26">
              <PlayIcon size={20} className="mr-2" data-id="element-27" />
              Watch Video
            </button>
          </div>
        </div>
      </div>
      {/* Scroll Down Indicator */}
      <div className="absolute bottom-8 left-0 right-0 flex justify-center" data-id="element-28">
        <button onClick={() => {
        const countryInfoSection = document.getElementById('country-info');
        if (countryInfoSection) {
          countryInfoSection.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }} className="animate-bounce p-2 rounded-full bg-white/20 backdrop-blur-sm text-white hover:bg-white/30 transition-colors" data-id="element-29">
          <ChevronDownIcon size={24} data-id="element-30" />
        </button>
      </div>
      {/* Video Modal */}
      {videoModalOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-75" onClick={() => setVideoModalOpen(false)} data-id="element-31">
          <div className="relative w-full max-w-4xl" onClick={e => e.stopPropagation()} data-id="element-32">
            <div className="aspect-video bg-black rounded-lg overflow-hidden" data-id="element-33">
              <iframe src="https://www.youtube.com/embed/linlz7-Pnvw?autoplay=1" title="Switzerland Travel Video" className="w-full h-full" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-34"></iframe>
            </div>
            <button className="absolute top-4 right-4 p-2 bg-black/50 rounded-full text-white hover:bg-black/70" onClick={() => setVideoModalOpen(false)} data-id="element-35">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-36">
                <line x1="18" y1="6" x2="6" y2="18" data-id="element-37"></line>
                <line x1="6" y1="6" x2="18" y2="18" data-id="element-38"></line>
              </svg>
            </button>
          </div>
        </div>}
    </div>;
}